import { FieldsetDesignTokens } from '@primeuix/themes/types/fieldset';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/fieldset/index.ts
const fs = tDeep(componentCommon.fieldset);

export const FieldsetTelekomDT: FieldsetDesignTokens = {
  root: {
    background: fs.background,
    color: fs.color,
    borderColor: fs.border.color,
    borderRadius: fs.border.radius,
    padding: `${fs.padding.top} ${fs.padding.right} ${fs.padding.bottom} ${fs.padding.left}`,
  },
  legend: {
    background: fs.legend.background,
    hoverBackground: fs.legend.hover.background,
    color: fs.legend.color,
    hoverColor: fs.legend.hover.color,
    borderRadius: fs.legend.border.radius,
    borderWidth: tNum(componentCommon.fieldset.legend.border.width),
    borderColor: fs.legend.border.color,
    padding: `${fs.legend.padding.y} ${fs.legend.padding.x}`,
    gap: fs.legend.gap,
    fontWeight: tNum(componentCommon.fieldset.legend.font.weight),
    focusRing: {
      width: fs.legend.focus.ring.width,
      color: fs.legend.focus.ring.color,
      offset: fs.legend.focus.ring.offset,
    },
  },
  toggleIcon: {
    color: fs.toggle.icon.color,
    hoverColor: fs.toggle.icon.hover.color,
  },
  content: {
    padding: fs.content.padding,
  },
};
